import React, {Component} from 'react';
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import IconCard from '../../Components/Member/IconCard';
import Api from '../../Components/Api';

UIkit.use(Icons);

export default class SmartHealthDepartment extends Component {

  state = {
    department: <span uk-spinner=""></span>
  }

  componentDidMount() {
    this.departmentGet();
  }

  async departmentGet() {
    var {department} = await Api.member('SmartHealthDepartment');
    this.setState({department});
  }

  render() {
    return <IconCard option={{
      backgroundColorLeft: '#008385',
      backgroundColorRight: '#00b5b8',
      icon: 'layers',
      title: 'Dept.',
      caption: '',
      value: this.state.department || 0
    }} />
  }
};
